import React, { useState, useEffect } from 'react';
import { Tree, Button, Spin, Layout, Space, Row, Col, Tooltip } from 'antd';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import Header166 from '../header/header';
import AvanceModal from './PoaAvanceModalSostenibilidad'

import './Poa.css';
import PoaSostenibilidadActividades from './PoaSostenibilidadActividades';
import { useNavigate, useParams } from "react-router-dom";

import { getPoasSostenibilidad } from "../../services/sostenibilidad/poaSosteibilidad";
import ExportExcelComponent from "./PoaSostenivilidadExport";

const { Content, Sider } = Layout;


const PoaSostenibilidad = () => {

    const navigate = useNavigate(); // 🔹 Hook para navegar
    const { codigoInterno } = useParams();


    const [treeData, setTreeData] = useState([]);
    const [dataCompleta, setDataCompleta] = useState([]); // Estado para la data completa
    const [selectedItem, setSelectedItem] = useState(null);

    const [loading, setLoading] = useState(true);
    const [expandAll, setExpandAll] = useState(false);
    const [showCards, setShowCards] = useState(false);
    const [collapsed, setCollapsed] = useState(false);

    const [expandedKeys, setExpandedKeys] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [autoExpandParent, setAutoExpandParent] = useState(true);
    const onExpand = (newExpandedKeys) => {
        setExpandedKeys(newExpandedKeys);
        setAutoExpandParent(true);
    };
    const toggleTreeVisibility = () => {
        setCollapsed(!collapsed);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {

                if (!codigoInterno) {
                    console.warn("⚠️ No se proporcionó un código interno.");
                    return;
                }
                const dataPOAS = await getPoasSostenibilidad(codigoInterno);
                const dataOriginal = structuredClone(dataPOAS.poas);  // 👈 Copia profunda
                setDataCompleta(dataOriginal);

                const data = dataPOAS.poas;
                // Filtrar los nodos hasta el tercer nivel
                const filteredData = data.map(item => {
                    // Filtrar los hijos de primer nivel (segundo nivel)
                    if (item.children && item.children.length > 0) {
                        item.children = item.children.map(child => {
                            // Filtrar los hijos de segundo nivel (tercer nivel)
                            if (child.children && child.children.length > 0) {
                                child.children = child.children.filter(grandchild => !grandchild.children);
                            }
                            return child;
                        });
                    }

                    return item;
                });

                setTreeData(filteredData);

                // Siempre expande el nodo raíz '0' al cargar los datos
                setExpandedKeys(keys => {
                    if (!keys.includes('0')) {
                        return [...keys, '0', 'producto_1'];
                    }
                    return [...keys, 'producto_1'];
                });


                if (!expandAll && data.length > 0) {
                    const initialKeysToExpand = data.slice(0, 9).map(item => item.key);
                    setExpandedKeys(initialKeysToExpand);
                }

            } catch (error) {
                console.error('Error fetching file tree:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [expandAll]);


    const clearHighlight = (nodes) => {
        nodes.forEach(node => {
            node.highlighted = false; // Establece todos los nodos como no destacados
            if (node.children) {
                clearHighlight(node.children); // Recursivamente limpia los hijos si existen
            }
        });
    };

    const getParentKey = (key, tree) => {
        let parentKey;
        for (let i = 0; i < tree.length; i++) {
            const node = tree[i];
            if (node.children) {
                if (node.children.some((item) => item.key === key)) {
                    parentKey = node.key;
                } else if (getParentKey(key, node.children)) {
                    parentKey = getParentKey(key, node.children);
                }
            }
        }
        return parentKey;
    };

    const toggleExpandAll = () => {
        setExpandAll(!expandAll); // Invierte el estado de expansión global

        if (!expandAll) {

            // Expandir todos los nodos
            const keysToExpand = getAllKeysToExpand(treeData, 2, 'Participantes');
            setExpandedKeys(keysToExpand);

        } else {

            // Contraer todos los nodos excepto el nodo '0'
            setExpandedKeys(['0']); // Asegura que el nodo '0' esté expandido explícitamente
        }
    };

    const getAllKeysToExpand = (data, level, excludedName) => {
        let keys = [];
        const traverse = (nodes, currentLevel) => {
            if (currentLevel > level) return;
            nodes.forEach(node => {
                if (node.name !== excludedName) {
                    keys.push(node.key);
                    if (node.children) {
                        traverse(node.children, currentLevel + 1);
                    }
                }
            });
        };
        traverse(data, 1);
        return keys;
    };


    const findNodeByKey = (data, key) => {
        if (!Array.isArray(data)) return null; // Si no es un array, retorna null

        for (const node of data) {
            if (node.key === key) {
                return node; // Retorna el nodo completo en lugar de solo sus hijos
            }
            if (node.children?.length) {
                const found = findNodeByKey(node.children, key);
                if (found) return found; // Retorna el nodo encontrado
            }
        }
        return null; // Si no encuentra el nodo, retorna null
    };

    const handleSelect = async (selectedKeys, info) => {
        const selectedNode = info.node;
        // Buscar el nodo completo en `dataCompleta`
        const foundNode = findNodeByKey(dataCompleta, selectedNode.key);

        if (foundNode) {
            // Guardar el nodo completo en el estado
            setSelectedItem(foundNode);
        } else {
            console.warn("⚠️ Nodo no encontrado en dataCompleta");
            setSelectedItem(null);
        }

        setShowCards(false);
    };


    const findNodeInData = (data, key) => {
        for (let item of data) {
            if (item.key === key) {
                return item;
            } else if (item.children) {
                const found = findNodeInData(item.children, key);
                if (found) return found;
            }
        }
        return null;
    };




    const findNode = (nodes, key) => {
        for (const node of nodes) {
            pathToNode.push(node);
            if (node.key === key) {
                return true;
            }
            if (node.children && findNode(node.children, key)) {
                return true;
            }
            pathToNode.pop();
        }
        return false;
    };


    const titleRenderer = (node) => {
        if (!node?.title) return <span>Sin título</span>;

        // 🟢 Expresión regular para detectar "FACTOR X."
        const factorRegex = /^(FACTOR \d+)\./i;
        const match = node.title.match(factorRegex);

        // 📌 Si el título comienza con "FACTOR X.", mostrar solo "FACTOR X."
        const displayTitle = match ? match[1] + "." : node.title;
        const tooltipTitle = node.title; // Mantiene el texto completo en el tooltip

        return (
            <Tooltip title={tooltipTitle} color='#87d068' placement="right">
                <span className={node.highlighted ? 'highlightedNode' : ''}>{displayTitle}</span>
            </Tooltip>
        );
    };

    const updateNodoInParent = (updatedNodo) => {

        setSelectedItem(updatedNodo); // 🔥 Actualizamos el nodo en el estado del padre
    };



    // Define la función findPathToNode antes de usarla
    const findPathToNode = (treeData, key) => {
        const path = [];

        const findNode = (nodes, key) => {
            for (const node of nodes) {
                path.push(node);
                if (node.key === key) {
                    return true;
                }
                if (node.children && findNode(node.children, key)) {
                    return true;
                }
                path.pop();
            }
            return false;
        };

        findNode(treeData, key);
        return path;
    };

    const pathToNode = selectedItem ? findPathToNode(treeData, selectedItem.key) : [];



    return (
        <Layout className="container">
            {loading ? (
                <div className="text-center">
                    <Spin size="large" />
                </div>
            ) : (
                <div className="container py-3">
                    <div className="row mb-2 d-flex align-items-center">
                        <Header166 type="poa" />
                        <div className="col-md-4 d-flex justify-content-center align-items-center flex-column">
                            <h4 className="text-center mb-2">UTF COL 188 COL<br />POA: {codigoInterno}</h4>
                            <div>
                                <ExportExcelComponent jsonData={dataCompleta} codigoInterno={codigoInterno} />

                            </div>
                        </div>
                    </div>
                    <div style={{ marginBottom: 8, textAlign: 'left' }}>
                        <h6 onClick={toggleTreeVisibility} style={{ cursor: 'pointer' }}>
                            POA: {codigoInterno} |
                            {collapsed ? <MenuUnfoldOutlined style={{ color: '#1677ff', paddingLeft: '5px' }} /> : <MenuFoldOutlined style={{ color: '#1677ff', paddingLeft: '5px' }} />}
                        </h6>
                    </div>
                    <Layout style={{ minHeight: '100vh' }}>
                        <Sider
                            width={230}
                            collapsedWidth={0}
                            className="site-layout-background"
                            collapsed={collapsed}
                            collapsible
                            trigger={null}
                            onCollapse={toggleTreeVisibility}
                            style={{ transition: 'all 0.3s' }}
                        >

                            {!collapsed && (
                                <Tree
                                    treeData={treeData}
                                    expandedKeys={expandedKeys}
                                    onExpand={onExpand}
                                    onSelect={handleSelect}
                                    autoExpandParent={autoExpandParent}
                                    titleRender={titleRenderer}
                                    showLine={true}
                                />
                            )}
                        </Sider>
                        <Layout style={{ padding: '0 24px 24px' }}>
                            <Content
                                className="site-layout-background"
                                style={{
                                    padding: 0,
                                    margin: 0,
                                    minHeight: 280,
                                }}
                            >
                                {selectedItem && (
                                    <Space direction="vertical" style={{ width: '100%' }} size="large">

                                        <Row gutter={0} justify="center" align="middle">
                                            <Col span={24}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <h4 style={{ fontSize: '16px', fontWeight: 'bold', margin: 0 }}>
                                                        {selectedItem ? (selectedItem.title || 'Sin título') : 'Sin elemento seleccionado'}
                                                    </h4>

                                                    <AvanceModal selectedItem={selectedItem} />
                                                </div>

                                                <PoaSostenibilidadActividades
                                                    nodo={selectedItem}
                                                    codigoInterno={codigoInterno}
                                                    updateNodoInParent={updateNodoInParent} // ✅ Pasamos la función
                                                />
                                            </Col>
                                        </Row>
                                    </Space>
                                )}


                            </Content>
                        </Layout>
                    </Layout>
                </div>
            )
            }
        </Layout >
    );
};

export default PoaSostenibilidad;
